
import React, { lazy, Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/auth/AuthContext';
import SEO from '@/components/SEO';

const Landing = lazy(() => import('./Landing'));

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
  </div>
);

const Index = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  // If user is logged in, redirect to dashboard
  React.useEffect(() => {
    if (currentUser) {
      navigate('/dashboard');
    }
  }, [currentUser, navigate]);

  // Show landing page for non-authenticated users
  return (
    <>
      <SEO />
      <Suspense fallback={<PageLoader />}>
        <Landing />
      </Suspense>
    </>
  );
};

export default Index;
